const handleValidationMessage = (t: Function, message: any) => {
    if (typeof message === 'object') {
        return t(message.key, message.values)
    } else {
        return t(message)
    }
}

export { handleValidationMessage }